<bfx-autoComplete
  #inputField
  [(ngModel)]="data.item"
  [label]="label"
  [suggestions]="data.filteredItems"
  (completeMethod)="search($event)"
  [disabled]="data.disabled || disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)"
  (onFocus)="onFocus($event)"
  (onBlur)="onBlur($event)"
  (onSelect)="onSelect($event)"
  dataKey="dataItem"
  field="label"
  [autoHighlight]="true"
  [skipSorting]="true"
  appendTo="body"
  delay="4"
  [state]="data.state"
  [dropdown]="true"
  [style]="{'width':'100%'}"
  [minLength]="1"
  [size]="'sm'"
  [inputStartContainer]="inputStartContainer"
  [bfxTooltip]="data.errorMsg ? data.errorMsg : null"
  tooltipPosition="top"
  tooltipStyleClass="bfx-tooltip-negative-bold"
>
  <ng-template #inputStartContainer let-chkBoxLabel>
    <p-checkbox
      [ngClass]="{
        'bfx-checkbox-enable-control': true,
        'icd__base__checkbox': true,
        'icd__base__checkbox--checked-active': auxCheckbox.value && !auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--checked-disabled': auxCheckbox.value && auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--unchecked-active': !auxCheckbox.value && auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--unchecked-disabled': !auxCheckbox.value && !auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--locked': disabled || locked
      }"
      binary="true"
      [disabled]="auxCheckbox.locked || disabled || locked || auxCheckbox.permanentLock"
      [style.display]="auxCheckbox.enabled ? 'flex' : 'none'"
      [bfxInputLabelOnClick]="chkBoxLabel"
      [(ngModel)]="auxCheckbox.value"
      (onChange)="onAuxCheckboxChange()"
    >
    </p-checkbox>
  </ng-template>
  <!-- FIXME: restore last favorite with a token- need to discuss concept with UX -->
  <!-- <ng-template let-dataItem pTemplate="item">
    <div
      class="ui-helper-clearfix"
      [ngClass]="{'bfx-autocomplete_dropdown-list_field': !dataItem.lastFavorite,
                  'bfx-autocomplete_dropdown-list_last-favorite': dataItem.lastFavorite}"
    >
      <div>{{dataItem.label}}</div>
    </div>
  </ng-template> -->
</bfx-autoComplete>
